<template>
    <div>
        <el-dialog :title="title" :visible.sync="visible" :close-on-click-modal="false" width="600px"
            class="ecology-files-dialog">
            <div class="content">
                <div class="mb-16" v-for="item in showList" :key="item.ossId || item.aliOssId">
                    <a :href="item.url" target="_blank">{{ item.fileName }}</a>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    data() {
        return {
            visible: false,
            title: '证明材料',
            showList: [],

        }
    },
    methods: {
        onShow(list, title) {
            this.showList = list || [];
            if (title) {
                this.title = title;
            }
            this.visible = true;
        }
    }
}
</script>

<style lang="scss" scoped>
.content {
    a {
        font-family: Alibaba PuHuiTi;
        font-size: 14px;
        font-weight: 600;
        text-align: right;
        color: #2a54d1;
    }
}

.mb-16 {
    margin-bottom: 16px;
}
</style>
<style lang="scss">
.ecology-files-dialog {
    .el-dialog__title {
        font-family: Alibaba PuHuiTi;
        font-size: 20px;
        font-weight: 600;
        color: #1a1a1a;
    }

    .el-icon-close {
        color: #333;
        font-weight: 600;
    }

    .el-dialog__body {
        padding: 10px 20px;
    }
}
</style>